<script setup>
import VideoCallButton from "@/components/Common/VideoCallButton.vue";
import { ref } from 'vue';
import { copyToClipboard } from "@/utils";
import { useVideoCallState } from "@/stores/videoCallState";
import i18n from "@/i18n";
import axios from "axios";
import configurationProvider from "@/Core/configurationProvider";
import { EventManager } from "@events";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },

  // Adding this will prevent a vue.js warning
  sectionType: {
    type: String,
    required: false,
  },

  // Adding this will prevent a vue.js warning
  modelValue: {
    type: Object,
    required: false
  }
});

async function openUrlShareDialog(){
  EventManager.getActionEmitter(props.rtcId).emit("open-whisper-url-share-dialog");
}

</script>
  
<template>
  <VideoCallButton icon="mdi-account-plus" @click="openUrlShareDialog()" />
</template>
  